export default "__VITE_ASSET__DwX6HqcO__"